<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>
      <div class="mainBox">
        <div class="fs_box">
          <div class="fs_top">
            <img class="imgbox" :src="banner?banner:`/static/images/Normal14/fs3.jpg`" />
          </div>
          <div class="fs_bottom">
            <img class="imgbox" src="/static/images/Normal14/fs1.jpg">
            <div class="fs_main fs_main_one" v-if="!isTrue">
              <p>防伪码：</p>
              <p><input class="tag_style input_style" :value="code" /></p>
              <p class="check_code">验证码：</p>
              <p class="code_box">
                <input class="code_style input_style" maxlength="4" v-model="ncode" />
                <input class="code_number" :value="vcode" readonly @click="rand()"/>
              </p>
              <p class="btn" @click="CodeVerify">查询</p>
            </div>
            <div class="fs_main fs_main_two" v-else>
              <p>防伪码：<a v-text="code"></a></p>
              <p>查询次数：<a v-text="datas.scan_count"></a></p>
              <p>查询时间：<a v-text="datas.scan_first_time"></a></p>
              <p>查询结果：您所查询的防伪码存在，谢谢~</p>
            </div>
          </div>
          <div class="fs-phone">招商热线：<a v-text="datas.business.linkphone"></a></div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
let self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
import ModelLoading from '@/components/ModelLoading.vue'
export default {
  name: 'Normal14',
  components: {
    'K-Loading': Loading,
    'K-Music': Music,
    'K-ModelLoading': ModelLoading
  },
  data() {
    return {
      isTrue: false,
      state: 100,
      code: null,
      vcode: null,
      ncode: null,
      datas: null,
      ModelLoading: false,
      banner: '',
      Loading: {
        type: 1,
        txt: "数据请求中..."
      }
    }
  },
  created() {
    self = this;
    document.querySelector('body').setAttribute('style', 'background-color:#FFF');
    this.selfAdaption(); //字体rem自适应
    this.rand();

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }

  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.query_count = response.data.meta.query_count;  //查询次数
          datas.query_first_time = response.data.meta.query_first_time;  //查询时间
          datas.query_first_address = response.data.meta.query_first_address;  //查询地点
          datas.verify = response.data.meta.verify; //防伪码
          datas.plan_id = response.data.meta.plan_id; //生码批次

          //公司名称特殊处理
          if(datas.business.name == '上海峰文商贸有限公司'){
            datas.business.name = '广州汗血马球商贸有限公司'
          }

          //自定义防伪查询语句
          if (datas.first_antifake_msg) {
            self.msg = datas.first_antifake_msg;
          }

          //自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
            if(datas.focus && datas.focus.length){
              self.banner = datas.focus[0].img
            }
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          self.$nextTick(function () {
            
          })

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    CodeVerify() {
			if(this.ncode == this.vcode){
				this.isTrue = true;
			}else{
				rand();
				alert("验证码输入错误！");
			}
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    selfAdaption (){
      //自适应像素
      var w = document.documentElement.getBoundingClientRect().width / 16
      document.documentElement.style.fontSize = w + "px"
    },
    rand () {
			const min = 1000;
			const max = 9999;
			this.vcode = Math.floor(Math.random()*(max-min))+min;
		}
  }
}
</script>

<style scoped>
i{
	font-style:normal;
}
input{
	background:none;  
	outline:none;  
	border:none;
	border-radius: 0;
	-webkit-appearance:none;
}
.imgbox{
	display: block;
	width:100%;
}
.fs_bottom{
	position: relative;
}
.fs_main{
	position: absolute;
	top:1rem;
	left:2rem;
	right:2rem;
}
.fs_main p{
	font-size:16px;
	margin-top:2px;
}
.tag_style{
	width: 215px;
}
.code_box{
	overflow: hidden;
}
.code_style{
	width: 140px;
	float: left;
}
.code_number{
	float: left;
	margin-left:8px;
	width: 65px;
	font-family: Arial,宋体;
	font-style: italic;
	color: green;
	border: 0;
	letter-spacing: 3px;
	font-weight: bolder;
	height: 25px;
	padding:1px;
	font-size: 15px;
	background-color: #DDD;
	text-align: center;
	word-spacing: normal;
}
.input_style{
	background-color: white;
	font: 400 13.3333px Arial;
	height: 25px;
	padding:0 2px;
	border:1px solid #CCC;
}
.check_code{
	margin-top:20px !important;
}
.btn{
	width: 80px;
	height: 33px;
	line-height: 33px;
	font-size:15px !important;
	margin-top:25px !important;
	text-align: center;
	background-image: linear-gradient(to top, #CCC 0%, #F9F9F9 100%);
	border:1px solid #CCC;
}
.fs_main_two p{
	margin-top:3px;
}
.fs_main_two a{
	word-break:break-all;
	word-wrap:break-word; 
}

.fs-phone{
  padding:0 20px 20px 20px;
  text-align: right;
  font-size: 14px;
  color: #f00;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/Normal14.vue